// extracted by mini-css-extract-plugin
export default {"logo":"RV1s3Tdt27Ciug5ib8Dq","navigation":"GFvT0SZUcS2Vnss7ABc2"};